{
  "#ESL": {
    "APP_TITLE": "ESL Link",
    "STORAGE_APP_TITLE": "ESL Lager",
    "TITLE": "Elektronische Etiketten Zuordnen",
    "ESL_CODE": {
      "MANUAL_INPUT": "Manuelle Eingabe",
      "PLACEHOLDER": "ESL Code",
      "SUBMIT": "Bestätigen",
      "OR": "Oder",
      "SCAN_HEADER": "ESL scannen",
      "SCAN_DESCRIPTION": "ESL mithilfe des integrierten Scanners suchen"
    },
    "SELECTION": {
      "SUBTITLE": "Lagerplatz Auswahl"
    },
    "ASSOCIATE_ITEMS": {
      "TITLE": "ESL Zuordnen",
      "SUBTITLE": "Artikel Auswahl",
      "MANUAL_INPUT": "Manuelle Eingabe",
      "PLACEHOLDER": "Artikelnummer",
      "OR": "Oder",
      "SCAN_HEADER": "Artikel scannen",
      "SCAN_DESCRIPTION": "Artikel mithilfe des integrierten Scanners suchen",
      "SUBMIT": "Speichern",
      "ESL": "ESL-Code",
      "ITEMS": "Artikel",
      "ADD": "Hinzufügen",
      "SUCCESS": "Der Artikel wurde dem ESL zugeordnet",
      "NO_ITEMS": "Es wurden noch keine Artikel hinzugefügt"
    },
    "ASSOCIATE": {
      "TITLE": "ESL Zuordnen",
      "SUBTITLE": "ESL Code erfassen"
    },
    "DISSOCIATE": {
      "TITLE": "Elektronische Etiketten Trennen",
      "SCAN": "Scannen",
      "ESL": "ESL-Code",
      "SUBMIT": "Zuordnung trennen",
      "SUCCESS": "Die Zuordnung von {{esl}} wurde aufgelöst"
    },
    "DIALOGS": {
      "ITEM": {
        "TITLE": "Artikel auswählen",
        "ITEM": "Artikel",
        "SUBMIT": "Auswählen"
      }
    },
    "PREVIEW": {
      "TITLE": "Vorschau",
      "DESCRIPTION": "Soll die Zuordnung zum Etikett erfolgen?",
      "CANCEL": "Abbrechen",
      "OK": "Zuordnen"
    },
    "CONFIGURATION": "Konfiguration",
    "COUNT": "Anzahl",
    "VARIANT": "Variante",
    "PREVIEW_QUESTION": "Diese Option legt fest, ob eine Vorschau angezeigt wird und eine Bestätigung erforderlich ist."
  },
  "#ESL_LINK": {
    "TITLE": "ESL",
    "ESL_CODE": {
      "MANUAL_INPUT": "Manuelle Eingabe",
      "PLACEHOLDER": "ESL Code",
      "SUBMIT": "Bestätigen",
      "OR": "Oder",
      "SCAN_HEADER": "ESL Scanner starten",
      "SCAN_DESCRIPTION": "oder ESL Code mithilfe des integrierten Scanners einlesen."
    },
    "ASSOCIATE_ITEMS": {
      "TITLE": "ESL Zuordnen",
      "MANUAL_INPUT": "Manuelle Eingabe",
      "PLACEHOLDER": "Artikelnummer",
      "OR": "Oder",
      "SCAN_HEADER": "Artikel Scanner starten",
      "SCAN_DESCRIPTION": "oder Artikel mithilfe des integrierten Scanners einlesen.",
      "SUBMIT": "Speichern",
      "ESL": "ESL-Code",
      "ITEMS": "Artikel",
      "ADD": "Hinzufügen",
      "SUCCESS": "Der Artikel wurde dem ESL zugeordnet",
      "NO_ITEMS": "Es wurden noch keine Artikel hinzugefügt"
    }
  }
}
